import { Instagram, Linkedin } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { SITE } from "@/lib/siteConfig";

export default function SocialFeedPlaceholder() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <FeedCard
        data-testid="instagram-feed-placeholder"
        platform="Instagram"
        handle="@thehumanproject.in"
        href={SITE.socials.instagram}
        Icon={Instagram}
        accent="#C86A4A"
      />
      <FeedCard
        data-testid="linkedin-feed-placeholder"
        platform="LinkedIn"
        handle="The Human Work Project"
        href={SITE.socials.linkedin}
        Icon={Linkedin}
        accent="#5F7F6B"
      />
    </div>
  );
}

function FeedCard({ platform, handle, href, Icon, accent, ...rest }) {
  return (
    <article
      {...rest}
      className="bg-paper rounded-2xl border border-[rgba(74,63,57,0.10)] p-6"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center"
            style={{ backgroundColor: `${accent}1f`, color: accent }}
          >
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <div className="font-display text-lg text-ink">{platform}</div>
            <div className="text-xs text-ink-muted">{handle}</div>
          </div>
        </div>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="text-xs font-semibold text-terracotta hover:text-[#8a4128] focus-ring rounded-md px-2 py-1"
        >
          Follow →
        </a>
      </div>
      <div className="mt-5 grid grid-cols-3 gap-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="aspect-square rounded-lg bg-[rgba(74,63,57,0.06)]" />
        ))}
      </div>
      <p className="mt-4 text-xs text-ink-muted">
        Feed integrates here once we go live. Follow us in the meantime.
      </p>
    </article>
  );
}
